<script setup lang="ts">
  import { trans } from '@bv/utils';

  import CallIntersectionAction from '../../CallIntersectionAction.vue';

  import AnswerHangupIcon from './AnswerHangupIcon.vue';
</script>

<template>
  <call-intersection-action>
    <template #icon>
      <answer-hangup-icon />
    </template>
    <template #label>
      {{ trans('voip.calls.call_action.answer_hangup_trans') }}
    </template>
  </call-intersection-action>
</template>
